import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function Checkbox() {
    return (
        <Draggable id="input-checkbox">
            <InputWrapper>
                Checkbox
                <div>
                    <input type="checkbox" className="checkbox" checked readOnly/>
                </div>
            </InputWrapper>
        </Draggable>
    )
}

export default Checkbox
